import { connect } from 'react-redux';

import { GlobalState } from 'ha/types/store';
import { withIntl } from 'ha/i18n';
import {
  getCollectionFilter,
  getPriceFilter,
  getCityName,
  getCountryName,
  getCountryCode,
  getAdvertiserName,
  getPageInfo,
  getMapCenter,
  getPriceAverage,
} from '../selectors';
import SearchMeta from '../components/SearchMeta';

const mapStateToProps = (state: GlobalState) => {
  const { lat: latitude, lng: longitude } = getMapCenter(state);
  const { priceMax, priceMin, currency } = getPriceFilter(state);
  const priceAverage = getPriceAverage(state);

  return {
    canonicalCollection: getCollectionFilter(state),
    priceMax,
    priceMin,
    priceAverage,
    currency,
    cityName: getCityName(state),
    countryName: getCountryName(state),
    countryCode: getCountryCode(state),
    advertiserName: getAdvertiserName(state),
    total: getPageInfo(state).total,
    latitude,
    longitude,
  };
};

export default withIntl(connect(mapStateToProps)(SearchMeta));
